/* eslint-disable */
// import Card from "@material-ui/core/Card";
// import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
// import CardTitle from "@saleor/components/CardTitle";
import Grid from "@saleor/components/Grid";
import RadioGroupField, {
  RadioGroupFieldChoice
} from "../RotaryRadioGroupField";
import { FormChange } from "@saleor/hooks/useForm";
import { RotaryTypeEnum } from "@saleor/types/globalTypes";
import React from "react";
import { FormattedMessage, IntlShape, useIntl } from "react-intl";

import {
  RotaryPageFormData
  // SaleDetailsPageTab
} from "../RotaryPage";

export interface RotaryTypeProps {
  data: RotaryPageFormData;
  disabled: boolean;
  onChange: FormChange;
  onTabClick?: any;
}

const useStyles = makeStyles(
  theme => ({
    root: {
      "&&": {
        paddingBottom: theme.spacing(1.5)
      }
    },
    flex: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      width: 1000
    },
    type: {
      fontWeight: 600
    }
  }),
  {
    name: "SaleType"
  }
);

function createChoices(intl: IntlShape): RadioGroupFieldChoice[] {
  return [
    {
      label: intl.formatMessage({
        defaultMessage: "Gift Box",
        description: "rotary type"
      }),
      value: RotaryTypeEnum.BLIND_BOX
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Rotary",
        description: "rotary type"
      }),
      value: RotaryTypeEnum.TURNTABLE
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Banner Box",
        description: "banner box"
      }),
      value: RotaryTypeEnum.BANNER_BOX
    }
  ];
}

const SaleType: React.FC<RotaryTypeProps> = props => {
  const { data, disabled, onChange } = props;

  const classes = useStyles(props);
  const intl = useIntl();

  const choices = createChoices(intl);
  // useEffect(() => {
  //   data.subjectImage=''
  //   data.subjectImageMb=''
  // }, [data.rotaryType]);

  return (
    <Grid>
      {/* <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Type",
          description: "percentage or fixed, header"
        })}
      /> */}
      <div className={classes.type}>
        <FormattedMessage defaultMessage="Type:" description="Type" />
      </div>
      {/* <Grid className={classes.root}> */}
      <RadioGroupField
        className={classes.flex}
        choices={choices}
        disabled={disabled}
        name={"rotaryType" as keyof RotaryPageFormData}
        value={data.rotaryType}
        onChange={e => {
          data.subjectImage = "";
          data.subjectImageMb = "";
          onChange(e);
        }}
      />
      {/* </Grid> */}
    </Grid>
    // <Card>
    //   <CardTitle
    //     title={intl.formatMessage({
    //       defaultMessage: "Type",
    //       description: "percentage or fixed, header"
    //     })}
    //   />
    //   <CardContent className={classes.root}>
    //     <RadioGroupField
    //       choices={choices}
    //       disabled={disabled}
    //       name={"rotaryType" as keyof RotaryPageFormData}
    //       value={data.rotaryType}
    //       onChange={onChange}
    //     />
    //   </CardContent>
    // </Card>
  );
};

SaleType.displayName = "SaleType";
export default SaleType;
